<rask-container-block>
    <ng-container header>Aktiviteter</ng-container>
    @if (aktiviteter) {
    <rask-list [data]="aktiviteter" [showHeader]="false">
        <rask-list-column>
            <ng-template let-row="row">
                <a [routerLink]="['/planera', $safeNavigationMigration(row.metadata?.entityId)]">
                    {{ row.titleShort }}
                </a>
                <a
                    [routerLink]="['/planera', $safeNavigationMigration(row.metadata?.entityId)]" target="_blank">
                    <i class="far fa-sm fa-external-link p-r-half"></i>
                </a>
            </ng-template>
        </rask-list-column>
        <rask-list-column>
            <ng-template let-row="row">
                <rask-icon [icon]="getStatusIcon(row.status)"></rask-icon>
            </ng-template>
        </rask-list-column>
        <rask-list-column>
            <ng-template let-row="row">
                @if (showDismiss(row)) {
                <rask-icon-button icon="far fa-trash-alt" (click)="dismissActivity(row.id)" negative></rask-icon-button>
                }
            </ng-template>
        </rask-list-column>
        <rask-list-column>
            <ng-template let-row="row">
                <rask-icon icon="fa-regular fa-up-right-from-square fa-rotate-270" (click)="openDetails(row)"
                    [clickToOpen]="true"></rask-icon>
            </ng-template>
        </rask-list-column>
    </rask-list>
    }
</rask-container-block>